import { styled } from 'theme';

const Input = styled('input', {
  // Reset
  appearance: 'none',
  borderWidth: '0',
  boxSizing: 'border-box',
  flexShrink: 0,
  fontFamily: 'inherit',
  lineHeight: '1',
  outline: 'none',
  padding: '0',
  width: '100%',
  WebkitTapHighlightColor: 'rgba(0,0,0,0)',
  '&::before': {
    boxSizing: 'border-box',
  },
  '&::after': {
    boxSizing: 'border-box',
  },

  // Custom
  backgroundColor: '$white',
  boxShadow: 'inset 0 0 0 1px $colors$border1',
  borderRadius: '$sm',
  color: '$primary',
  px: '$6',
  letterSpacing: '$wide',
  transition: 'box-shadow 200ms',
  '&:hover': {
    boxShadow: '$colors$secondary 0px 0px 0px 1px inset',
  },
  '&:focus': {
    boxShadow:
      '$colors$secondary 0px 0px 0px 1px inset, rgba(33, 0, 150, 0.25) 0px 1px 12px',
  },
  '&:read-only': {
    color: '$accessibleGrey',
  },
  '&:disabled': {
    pointerEvents: 'none',
    backgroundColor: '$canvas',
    color: '$accessibleGrey',
    cursor: 'not-allowed',
  },
  '&::placeholder': {
    color: '$accessibleGrey',
    opacity: '1',
  },
  '&[aria-invalid="true"], &.invalid': {
    boxShadow: 'inset 0 0 0 1px $colors$red700',
  },

  variants: {
    size: {
      sm: {
        height: '$10',
        px: '$3',
        fontSize: '$md',
        '@md': {
          fontSize: '$sm',
        },
      },
      md: {
        height: '$12',
        fontSize: '$md',
      },
      lg: {
        height: '70px',
        fontSize: '$2xl',
      },
    },
  },

  defaultVariants: {
    size: 'md',
  },
});

export default Input;
